import { type ReactNode } from 'react';
import { type ButtonSize, iconSizeFor } from './buttonStyles';
import Icon, { type IconName } from './Icon';

interface ButtonContentProps {
  size?: ButtonSize;
  icon?: IconName;
  iconRight?: IconName;
  /** A spinner in place of the left icon, and no right icon. */
  loading?: boolean;
  children?: ReactNode;
}

/** The inside of a Button or ButtonLink: icon, label, icon. */
export default function ButtonContent({
  size,
  icon,
  iconRight,
  loading = false,
  children
}: ButtonContentProps): JSX.Element {
  const iconSize = iconSizeFor(size);
  const left = loading ? 'spinner' : icon;
  return (
    <>
      {left !== undefined && <Icon name={left} size={iconSize} />}
      {children != null && <span>{children}</span>}
      {!loading && iconRight !== undefined && (
        <Icon name={iconRight} size={iconSize} />
      )}
    </>
  );
}
